<template>
    <div class="toast" :class="classes">
        <WBIcon :name="icon" class="toast__icon" />
        <div class="toast__message">
            <p class="toast__title">
                {{ message.title }}
            </p>
            <p v-if="message.subtext" class="toast__subtext">
                {{ message.subtext }}
            </p>
        </div>
    </div>
</template>

<script lang="ts" setup>
    // Пропсы для настройки тоста
    import { type ToastItem, ToastType } from '~/src/shared/components/ui/toast/types'

    const props = withDefaults(defineProps<ToastItem>(), {
        type: ToastType.success,
        duration: 3000,
    })

    const classes = computed(() => ({
        [`_${props.type}`]: props.type,
    }))

    const icon = computed(() => {
        switch (props.type) {
            case ToastType.error:
                return 'error-filled'
            case ToastType.warning:
                return 'warning-filled'
            default: return 'success-filled'
        }
    })
</script>

<style scoped lang="scss">
    .toast {
        display: flex;
        gap: 12px;
        padding: 20px;
        border-radius: 16px;
        font-size: 16px;
        color: white;
        box-shadow: 0 4px 10px rgb(0 0 0 / 20%);

        &._success {
            background-color: var(--success-color);
        }

        &._error {
            background-color: var(--error-color);
        }

        &._warning {
            background-color: var(--warning-color);
        }

        &__icon {
            font-size: 20px;
        }

        &__title {
            @include mulish18b;
        }

        &__subtext {
            margin-top: 8px;

            @include mulish16r;
        }
    }
</style>
